import React from 'react';
import MDEditor from '@uiw/react-md-editor';

interface MarkdownEditorProps {
    value: string;
    onChange: (value: string) => void;
    placeholder?: string;
    height?: number;
    preview?: 'edit' | 'live' | 'preview';
}

/**
 * Reusable markdown editor component with toolbar for bold, italic, lists, links, etc.
 */
const MarkdownEditor: React.FC<MarkdownEditorProps> = ({
    value,
    onChange,
    placeholder = 'Write your description using markdown...',
    height = 200,
    preview = 'live',
}) => {
    return (
        <div data-color-mode="light" style={{ colorScheme: 'light' }}>
            <style>
                {`
          .w-md-editor {
            background-color: white !important;
            color: #333 !important;
          }
          .w-md-editor-text-input {
            color: #333 !important;
            -webkit-text-fill-color: #333 !important;
          }
          .w-md-editor-text-pre > code {
            color: #333 !important;
          }
          .w-md-editor-text-pre > code .token {
            color: #333 !important;
          }
          .w-md-editor textarea {
            color: #333 !important;
            -webkit-text-fill-color: #333 !important;
          }
          .wmde-markdown {
            background-color: white !important;
            color: #333 !important;
          }
        `}
            </style>
            <MDEditor
                value={value}
                onChange={(val) => onChange(val || '')}
                preview={preview}
                height={height}
                textareaProps={{
                    placeholder,
                    style: {
                        color: '#333',
                        WebkitTextFillColor: '#333',
                    },
                }}
            />
        </div>
    );
};

export default MarkdownEditor;
